app.service('individualOfferHashChecker', function (front, loading, modal, productStateOutletModal, sufficientOutletCategory) {

	let hash = {
		value: null,
		setUp() {
			this.value = document.location.hash;
		},
		contains(hash) {
			return this.value.indexOf(hash) > -1;
		}
	};

	function check() {
		if(!front.ole) return;

		hash.setUp();
		if (hash.contains("outlet-dostateczny")) {
			if(hash.contains("|hu-") && hash.contains('|preview')) {
				const huCode = getHuCode();
				showIndividualOutletOffer(huCode);
				return;
			}
			productStateOutletModal.show();
		}
	}

	function getHuCode(position = 2) {
		const regexp = /(outlet-[a-z]+)\|hu-([0-9a-z]+)/g;
		const result = regexp.exec(hash.value);
		return result ? result[position] : false;
	}

	function getProductAvailability(huCode) {
		return $.ajax({
			method: 'GET',
			url: '/outletProduct-finder.ltr',
			data: { huCode }
		});
	}

	function showIndividualOutletOffer(huCode) {
		getProductAvailability(huCode)
			.then(sufficientOutletCategory.showIndividualOffer)
			.fail(() => modal.alert("Wystąpił błąd, spróbuj ponownie później."));
	}

	return {
		check
	};
});
